import { CodeScolaireState, CodeScolaire } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getAllCodesScolaires } from '@/services/api/codeScolaire/api';

import _ from 'lodash';

const namespaced: boolean = true;

export const state: CodeScolaireState = {
	listCodesScolaires: []
};

export const mutations: MutationTree<CodeScolaireState> = {
	mutateCodesScolaires(state: CodeScolaireState, newListCodesScolaires: CodeScolaire[]): void {
		state.listCodesScolaires = newListCodesScolaires;
	}
};

export const actions: ActionTree<CodeScolaireState, RootState> = {
	loadCodesScolaires(state): Promise<void> {
		return new Promise((resolve, reject) => {
			if (_.isEmpty(state.state.listCodesScolaires)) {
				getAllCodesScolaires()
					.then((response: any) => {
						state.commit('mutateCodesScolaires', _.get(response, 'data.value.etablissements'));
						state.state.listCodesScolaires.forEach((codeScolaire) => {
							codeScolaire.libelleAffichage = codeScolaire.codeEtablissement
							+ ' - ' + codeScolaire.appellationOfficielle
							+ ' - ' + codeScolaire.codePostal
							+ ' - ' + codeScolaire.libelleCommune;
						});
						resolve();
					})
					.catch(() => {
						reject();
					});
			} else {
				resolve();
			}
		});
	},
	updateListCodesScolaires(state, newListCodesScolaires: CodeScolaire[]): void {
		state.commit('mutateCodesScolaires', newListCodesScolaires);
	}
};

export const getters: GetterTree<CodeScolaireState, RootState> = {
	getListCodesScolaires(state) {
		return state.listCodesScolaires;
	}
};

export const codesScolaires: Module<CodeScolaireState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
